import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataConfigurationComponent } from './components/data-configuration/data-configuration.component';
import { DataPreviewComponent } from './components/data-preview/data-preview.component';
import { DataPullConfigurationComponent } from './components/data-pull-configuration/data-pull-configuration.component';
import { StoringDataComponent } from './components/storing-data/storing-data.component';
import { ConfigureDataSourceComponent } from './components/configure-data-source/configure-data-source.component';
import { AvailableDataSourcesComponent } from './components/available-data-sources/available-data-sources.component';
import { UploadFilesComponent } from './components/upload-files/upload-files.component';
import { canDeactivateFn } from '../../guards/upload-data.guard';

const routes: Routes = [
  { path: 'data_sources', component: ConfigureDataSourceComponent },
  { path: 'available-data', component: AvailableDataSourcesComponent },
  {
    path: 'upload_files/:file_name',
    component: UploadFilesComponent,
    canDeactivate: [canDeactivateFn],
  },
  {
    path: 'data_configuration',
    component: DataConfigurationComponent,
    children: [
      {
        path: 'data_pull/:data_name',
        component: DataPullConfigurationComponent,
      },
      {
        path: 'data_pull',
        component: DataPullConfigurationComponent,
      },
      { path: 'data_preview/:data_name', component: DataPreviewComponent },
      { path: 'save/:data_name', component: StoringDataComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DataManagementRoutingModule {}
